import { atom } from "recoil";
import {
  SignupForm,
  LoginForm,
  ResetPasswordForm,
  BouncePrevention,
  OnboardingSteps,
  OnboardingForm,
} from "../types/forms";
import { AppUser } from "../types/users";
import { Organization } from "../types/organizations";

export const signedInUserAtom = atom<AppUser | null>({
  key: "signedInUserAtom",
  default: null,
});

export const signupFormAtom = atom<SignupForm>({
  key: "signupFormAtom",
  default: {
    name: "",
    organizationName: "",
    email: "",
    password: "",
    passwordConfirmation: "",
  },
});

export const onboardingFormAtom = atom<OnboardingForm>({
  key: "onboardingFormAtom",
  default: {
    currentStep: OnboardingSteps.ChooseIntegration,
    bouncePrevention: BouncePrevention.AddSequences,
    isOutreachAdmin: false,
  },
});

export const loginFormAtom = atom<LoginForm>({
  key: "loginFormAtom",
  default: {
    email: "",
    password: "",
  },
});

export const resetPasswordFormAtom = atom<ResetPasswordForm>({
  key: "resetPasswordFormAtom",
  default: {
    email: "",
  },
});

export const organizationAtom = atom<Organization | null>({
  key: "organizationAtom",
  default: null,
});

export const extensibilitySdkInitializedAtom = atom<boolean>({
  key: "extensibilitySdkInitializedAtom",
  default: false,
});

/**
 * HubSpot orgs only: the dashboard page on screen. "insights" is the reports
 * dashboard; every other value is an item of the settings panel ("users",
 * "account", "billing", ...). The top bar and the side navigation both set it.
 */
export const hubspotPageAtom = atom<string>({
  key: "hubspotPageAtom",
  default: "insights",
});

/**
 * HubSpot orgs only: a report the top bar's search picked, for Insights to
 * open (the dashboard, and the card on it to scroll to). Insights clears it.
 */
export const hubspotInsightsTargetAtom = atom<{ dashboard: string; card?: string } | null>({
  key: "hubspotInsightsTargetAtom",
  default: null,
});

/** HubSpot orgs only: a user the top bar's search picked, for the Users page to search for. It clears it. */
export const hubspotUsersSearchAtom = atom<string>({
  key: "hubspotUsersSearchAtom",
  default: "",
});

export const outreachOrgIdAtom = atom<string | null>({
  key: "outreachOrgIdAtom",
  default: null,
});

/** Pending job changes in the signed-in user's scope, for the Job changes nav badge; null until loaded. */
export const jobChangesPendingAtom = atom<number | null>({
  key: "jobChangesPendingAtom",
  default: null,
});
